<template>
  <img src="@/assets/images/logos/company-logo-gfss.webp"/>
</template>
<script setup>
</script>